<template>
  <div class="connect-box" v-if="props.type == '2-3'">
    <!-- v-show="item.handle || item.default_handle" -->
    <div class="connect-line" v-for="(item, index) in RegisterStore.verifityList" :key="index" >
      <div class="social">
        <svg-icon :name="item.icon" />
        <div class="name">{{ item.default_handle? item.default_handle: item.name }}</div>
      </div>
      <!-- v-if="(item.default_handle && !item.handle)"-->
      <div class="connect-btn-box">
        <el-button type="primary" @click="connectPopup(item)" v-if="(item.default_handle && !item.connect_status) || !item.default_handle" >Connect</el-button>
        <el-button v-if="item.connect_status" @click="openDisConnectDialog(item)">Disconnect</el-button>
        <!-- <el-button type="primary" v-if="item.handle && handleFullyConnectBtn(item)" @click="connectPopup(item)">Fully Connect</el-button> -->
      </div>
    </div>
  </div>

  <HandleSelector @updateHandle="updateHandle" v-if="props.type == '2-4'"/>

  <!-- 詢問要多連哪一個 -->
  <el-dialog v-model="dialogVisible" :title="`Connect your accounts`" class="connect-list-dialog">
    <el-scrollbar>
      <div class="connect-box">
        <div class="connect-line" v-for="(item, index) in store.initSocial" :key="index" v-show="item.show">
          <div class="social">
            <svg-icon :name="item.icon" />
            <div class="name">{{ item.name }}</div>
          </div>
          <el-button type="primary" @click="connectPopup(item, 'spec')">Connect</el-button>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>

  <DisConnectDialog ref="disConnectDialogRef" @disConnect="handleDisconnect(disConnectItem)" />
  <!-- 連接條款 -->
  <ConnectSocialDialog v-model:dialogValue="dialogConnectValue" :need_token="true" :is_more_register="props.type=='2-4'" :is_verifity="props.type=='2-3'"/>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, reactive, computed, watch,onMounted,onUnmounted } from 'vue';
import { useRegisterStore } from '@/stores/RegisterStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useNotification } from '@shared/components/ui/notification';
import ConnectSocialDialog from '@shared/components/settings/ConnectSocialDialog.vue';
import DisConnectDialog from '@shared/components/settings/DisConnectDialog.vue';
import HandleSelector from '@/components/settings/HandleSelector.vue';
import ajax from '@/utils/Ajax';
import emitter from '@shared/utils/EventBus';

const props = defineProps({
  type: {
    type: String,
    default: '2-3' //2-4
  },
});
const emit = defineEmits(['updateHandle']);
const dialogVisible = ref(false);
const router = useRouter();
const { openNotBottom } = useNotification();
const RegisterStore = useRegisterStore();
const store = useGlobalStore();
const dialogConnectValue = ref({//scocial
  open: false,
  data: null,
  step: 2 //(step1 is for fb connect)
});

const hadConnectSocial = ref([]);//connected social
const disConnectDialogRef=ref(null);
const disConnectItem=ref(null);
const pickHandleValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});
//+++++++++++++++++++++
//function
//+++++++++++++++++++++
const connectPopup = (item, spec) => {
  dialogConnectValue.value.open = true;
  dialogConnectValue.value.data = item;
  if(item.status===10 || item.status===15){
    dialogConnectValue.value.step = 1;
  }else{
    dialogConnectValue.value.step = 2;
  }
  window.localStorage.setItem('CREATOR_PROTAL_new_add_social', true);
};

const updateHandle=(val)=>{
  emit('updateHandle', val);
};

const openDisConnectDialog = (item) => {
  disConnectItem.value = item;
  disConnectDialogRef.value.open();
};

const handleDisconnect = async (item) => {
  console.log('disConnectItem.value',disConnectItem.value)
  let date = {
    social_platform: disConnectItem.value.social_platform,
    handle: disConnectItem.value.handle
  }
  RegisterStore.loading=true;
  ajax.post('/disconnect-social-account', date).then(async (res) => {
    openNotBottom(`${disConnectItem.value.name} connection removed`, 'success');
    disConnectDialogRef.value.close();
    setTimeout(async () => {
      await RegisterStore.handleRegisterSocial();
    }, 1000);
  }).catch((err) => {
    RegisterStore.loading = false;
    openNotBottom('Connection removed fail', 'error');
  });

};

defineExpose({
  open: () => { dialogVisible.value = true; },
  close: () => { dialogVisible.value = false; },
});


onMounted(() => { 
  emitter.on('open-connect-dialog', () => {
    dialogVisible.value = true;
  });
});

onUnmounted(() => {
  emitter.off('open-connect-dialog');    
});
</script>

<style lang="scss">
.connect-box {
  width: 100%;
  @include flexCenter();
  flex-wrap: wrap;
  gap: 16px;

  .connect-line {
    @include flexCenter();
    justify-content: center;
    width: 100%;

    .social {
      flex: 1;
      font-size: 16px;
      color: var(--Text-primary);
      @include flexCenter();
      gap: 8px;

      .svg-icon {
        width: 24px;
        height: 24px;
        fill: var(--Text-primary);
      }
    }
  }

  p {
    margin-right: 8px;
    font-size: 12px;
    color: var(--Text-secondary);
  }

  .ui-link {
    font-size: 12px;
  }
}
</style>
